import { useAppDispatch, useAppSelector } from '@hooks/redux';
import { createCounterpartyApi } from '@http/counterparties';
import { getCountriesApi } from '@http/global';
import { Button, Divider, Form, Input, Select } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ForeigsForm = () => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const countries = useAppSelector(state => state.globalReducer.countries);

  const filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  const submit = (values: any) => {
    dispatch(createCounterpartyApi({ ...values, counterparty_type: 'FOREIGN' })).then(data => {
      if (data) {
        navigate('/counterparties');
      }
    });
  };

  useEffect(() => {
    dispatch(getCountriesApi());
  }, []);

  return (
    <Form form={form} name='OwnAccounts' onFinish={submit}>
      <div className='mt-3'>
        <p className='text-base color-active font-semibold mb-4'>{t('Основная информация')}</p>

        <div className='md:grid grid-cols-5'>
          <p className='col-span-1 text-bs color-title'>{t('Name')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='title' rules={[{ required: true, message: `${t('Required')}` }]}>
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('TIN')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='tax_id'>
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <Divider />
        <p className='text-base color-active font-semibold mb-4'>{t('Информация о контрагенте')}</p>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('Account number')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='receiving_ac'>
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('KPP')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='receiver_kpp'>
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('Country')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='receiver_country'>
              <Select
                size='large'
                style={{ width: '100%' }}
                allowClear
                showSearch
                optionFilterProp='children'
                filterOption={filterOption}
                options={countries}
                placeholder={`${t('Enter Country')}`}
              />
            </Form.Item>
          </div>
        </div>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('City')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='receiver_city'>
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('Address')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='receiver_address'>
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <Divider />

        <p className='text-base color-active font-semibold mb-4'>{t('Информация о банке')}</p>
        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('Bank name')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='receiver_bank_name'>
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('Swift')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='receiver_bank_swift'>
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('BIC')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='bank_code'>
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('Country')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='receiver_bank_country'>
              <Select
                size='large'
                style={{ width: '100%' }}
                allowClear
                showSearch
                optionFilterProp='children'
                filterOption={filterOption}
                options={countries}
                placeholder={`${t('Enter Country')}`}
              />
            </Form.Item>
          </div>
        </div>

        <Divider />

        <p className='text-base color-active font-semibold mb-4'>{t('Contacts')}</p>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('Phone number')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='phone_number'>
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('Email')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='email'>
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <div className='md:grid grid-cols-5 mt-7'>
          <div className='col-span-3 flex justify-end'>
            <Button type='primary' size='middle' htmlType='submit'>
              {t('Confirm')}
            </Button>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default ForeigsForm;
